import { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

import type { OneOnOneColorAllocation } from '@features/shared/api/typings';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const OPTIONS: {
  label: ReactNode;
  value: OneOnOneColorAllocation;
  disabled?: boolean;
}[] = [
  { label: 'Случайно', value: 'Random' },
  { label: 'Первый игрок — белыми', value: 'FirstWhite' },
];

export function OneOnOneColorInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Цвет фигур</FormLabel>
      <FormInput>
        <Controller
          name="oneOnOneSettings.oneOnOneColorAllocation"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs
              tabs={OPTIONS}
              onChange={onChange}
              value={value || 'Random'}
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
